namespace GeniuzPOS.SalePromoCamp {
    import fld = PsPromoHdRow.Fields
        @Serenity.Decorators.registerClass()
        export class PsPromoHdGrid extends Serenity.EntityGrid<PsPromoHdRow, any> {
            protected getColumnsKey() { return PsPromoHdColumns.columnsKey; }
            protected getDialogType() { return PsPromoHdDialog; }
            protected getIdProperty() { return PsPromoHdRow.idProperty; }
            protected getInsertPermission() { return PsPromoHdRow.insertPermission; }
            protected getLocalTextPrefix() { return PsPromoHdRow.localTextPrefix; }
            protected getService() { return PsPromoHdService.baseUrl; }
    
            constructor(container: JQuery) {
                super(container);
            }
            protected getButtons() {
                var buttons = super.getButtons();
                
                buttons.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );        
                
                buttons.push({
                    title: "Import From Excel",
                    hint: "Import Promo from Excel template",
                    cssClass: "upload-basicpromo-template-button",
                    icon: "fa-cloud-upload-alt",
                    separator: true,
                    onClick: () => {
                        const dialog = new Common.ImportBasicPromoDialog()
                        this.initDialog(dialog)
                        dialog.importState = () => {
                            Q.notifySuccess("Import from Excel successfully.")
                            this.refresh()
                        }
        
                        dialog.dialogOpen()
                    }
                })

                buttons.push({
                    title: "Download Template",
                    hint: "Download Excel template for Promo import",
                    cssClass: "download-basicpromo-template-button",
                    icon: "fa-download",
                    separator: true,
                    onClick: () => {
                        window.location.href = Q.resolveUrl("~/Services/Csi/DownloadBasicPromoTemplate");
                    }
                })
                
                return buttons;
            }
            protected createToolbarExtensions() {
                super.createToolbarExtensions();
        
                this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                    
                var groupingMixin = new Serenity.DraggableGroupingMixin({
                    grid: this
                });
        
                // setting ShipCountry, ShipCity columns as initially grouped for this sample
                // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
                // in OrderColumns.cs instead (recommended way)
                groupingMixin.plugin.setDroppedGroups(["  "]);
            }
            protected getSlickOptions() {
                var opt = super.getSlickOptions();
                // need to turn grouping panel ON for drag drop grouping to work properly
                opt.groupingPanel = true;
                return opt;
            }
          
            
        }
    }